import React from 'react';

import PropTypes from 'prop-types';

import { LinkButton } from '@adsk/alloy-react-button';
import { AlertWarningIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import SelectBox from '@adsk/alloy-select-box';

const StatusSelectBox = ({
  isLoading,
  loadError,
  loadErrorContent,
  menuRenderer,
  onRetry,
  children,
  ...rest
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  const renderLoadingStatus = () => {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '72px',
        }}
      >
        <ProgressRing />
      </div>
    );
  };
  const renderErrorStatus = () => {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '72px',
        }}
      >
        <AlertWarningIcon />
        <div
          style={{
            margin: '0 2px 0 6px',
            fontSize: '12px',
            lineHeight: '16px',
          }}
        >
          {loadErrorContent}
        </div>
        {onRetry && (
          <LinkButton
            style={{
              fontSize: '12px',
              lineHeight: '16px',
            }}
            onClick={onRetry}
          >
            {T.translate('TRY_AGAIN')}
          </LinkButton>
        )}
      </div>
    );
  };
  const StatusMenuRenderer = (args) => {
    const originMenuRenderer = menuRenderer || SelectBox.defaultMenuRenderer;
    if (isLoading) return renderLoadingStatus();
    if (loadError) return renderErrorStatus();
    return originMenuRenderer(args);
  };

  return isLoading || loadError ? (
    <SelectBox
      {...rest}
      searchable={false}
      options={[{ value: 'placeholder', label: 'placeholder' }]}
      menuRenderer={StatusMenuRenderer}
    />
  ) : (
    children({ ...rest })
  );
};

StatusSelectBox.defaultProps = {
  ...SelectBox.defaultProps,
  isLoading: false,
  loadError: false,
  children: (props) => <SelectBox {...props} />,
};

StatusSelectBox.propTypes = {
  ...SelectBox.propTypes,
  /**
   * whether it is loading options data
   */
  isLoading: PropTypes.bool,
  /**
   * whether it has error when loading options data
   */
  loadError: PropTypes.bool,
  /**
   * content to show when it has loading options data error
   */
  loadErrorContent: PropTypes.node,
  /**
   * callback for retrying to load options data
   */
  onRetry: PropTypes.func,
  /**
   * children renderer
   */
  children: PropTypes.func,
};

export default StatusSelectBox;
